<!-- container-xxl -->
<div class="content-wrapper p-0 my-application-outer-container">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="card">
		<h5 class="card-header">Search Filter</h5>
		<div class="card-body">
			<div class="users-list-filter">
				<form [formGroup]="searchform" autocomplete="off">
					<div class="row">
						<div class="col-12 col-md-3">
							<fieldset class="form-group">
								<input type="text" formControlName="SearchText" class="form-control"
									(change)="search()" placeholder="Search By Expert Name">
							</fieldset>
						</div>
						<div class="col-12 col-md-3">
							<fieldset class="form-group"> 
								<ng-select [items]="subjectType" bindLabel="subjectTypeName"
									bindValue="subjectTypeID" formControlName="Subject" 
									[closeOnSelect]="true"
									placeholder="Subject Type" (change)="search()">
								</ng-select> 
							</fieldset>
						</div>
						<div class="col-12 col-md-3">
							<fieldset class="form-group">
								<ng-select [items]="pageSizeList" bindLabel="pageSizeValue"
									bindValue="pageSizeValue" placeholder="Page Size" formControlName="PageSize"
									(change)="search()"> </ng-select>
							</fieldset>
						</div>
						<div class="col-12 col-md-3">
							<fieldset class="form-group">
								<ng-select [items]="sortByList" bindLabel="sortByName" bindValue="sortByValue"
									placeholder="Sort Order" formControlName="SortOrder" (change)="search()">
								</ng-select>
							</fieldset>
						</div>
					</div>
					<div class="row">
						<div class="col-12" style="text-align: center;">
							<button type="button" rippleeffect="" (click)="search()"
								class="btn btn-primary mr-1 waves-effect waves-float waves-light">Search</button>
							<button type="reset" rippleeffect="" (click)="resetFilter()"
								class="btn btn-outline-secondary waves-effect mr-1">Reset</button>
						</div>
						
					</div>
				</form>
			</div>
		</div>
	</div>
</div>

<section class="app-ecommerce-details">
	<div class="col-12" style="margin-top:-20px;">
		<div class="row pb-1">
			<div class="col-6 text-left"><h5>TOTAL RECORDS FOUND: {{totalRecords}}</h5></div>
			<div class="col-6 text-right">
			<button class="btn btn-primary" type="button" routerLink="/add-expert/"><i class="feather icon-plus-square "></i> Add Expert</button></div>
		</div>
	</div>

	<div class="card">
		<div class="card-body">
			
			<div class="table-responsive">
				<table class="table table-striped">
					<thead>
						<tr>
							<th scope="col" class="pl-5">Action</th>
							<th scope="col">First Name</th>
							<th scope="col">Last Name</th>
							<th scope="col">Email</th>
							<th scope="col">Mobile</th>
							<th scope="col">Subject Type</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of expertList; let $index=index">
							<th>
								<div class="btn-group icon-bg">
									<div class="input-group-append">
										<button class="btn btn-md" type="button" rippleEffect routerLink="/edit-expert/{{item.id}}"><i class="feather icon-edit"></i></button>
										<button *ngIf="item.is_active == 1" (click)="activeInActiveUser(item.is_active,item.id)" class="btn btn-md feather icon-user-check" stroke-width="2" type="button" rippleEffect></button>
										<button *ngIf="item.is_active == 0" (click)="activeInActiveUser(item.is_active,item.id)" class="btn btn-md feather icon-user-x" type="button" rippleEffect></button>
									</div>
								</div>
							</th>
							<td>{{item.firstName}}</td>
							<td>{{item.lastName}}</td>
							<td>{{item.email}}</td>
							<td>{{item.mobile}}</td>
							<td>{{item.subjectAreaName}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="card" *ngIf="expertList?.length == 0">
		<div class="card-body">
			<span>No records found.</span>
		</div>
	</div>
	<div>
		<ngb-pagination [collectionSize]="totalRecords" class="d-flex justify-content-center"
			[(page)]="pageAdvancedEllipses" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
			[pageSize]="pageSize" (pageChange)="loadPage($event)">
			<ng-template ngbPaginationFirst>First</ng-template>
			<ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
					[class]="'font-weight-bolder'"></span>Prev
			</ng-template>
			<ng-template ngbPaginationNext>Next<span [data-feather]="'chevron-right'"
					[class]="'font-weight-bolder'"></span>
			</ng-template>
			<ng-template ngbPaginationLast>Last</ng-template>
		</ngb-pagination>
	</div>
</section>

<ng-template #modalAE let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Add Expert</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="addExpertForm" autocomplete="off">
			<div class="form-group col-md-12">
				
			</div>
			
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>